import Reveal from "@/components/base/Reveal";
import { useSiteImage, useSiteImageAlt, useSiteText } from "@/lib/siteContent";

export default function EditorialBanner() {
  const image = useSiteImage(
    "editorial.banner",
    "https://readdy.ai/api/search-image?query=Editorial%20horizontal%20still%20life%20of%20three%20different%20womens%20shoes%2C%20a%20structured%20leather%20handbag%20and%20delicate%20gold%20jewelry%20arranged%20on%20a%20warm%20ivory%20surface%20with%20a%20deep%20bordeaux%20accent%20base%2C%20editorial%20lighting%2C%20true%20leather%20texture%2C%20generous%20empty%20ivory%20space%20on%20the%20left%20for%20text%2C%20no%20people%2C%20no%20text%2C%20no%20logos%2C%20no%20watermark&width=1600&height=900&seq=aur-banner-editorial-01&orientation=landscape&nocache=true",
  );
  const alt = useSiteImageAlt(
    "editorial.banner",
    "Sandálias, calçados fechados, bolsa de couro e semijoias da coleção Auréa em fundo marfim com detalhe bordô",
  );
  const eyebrow = useSiteText("editorial.eyebrow", "Editorial Auréa");
  const title = useSiteText("editorial.title", "Elegância que começa nos seus passos");
  const text = useSiteText(
    "editorial.text",
    "Modelos versáteis, texturas marcantes e acessórios que completam produções para diferentes momentos da vida real.",
  );
  const button = useSiteText("editorial.button", "Descobrir a coleção");

  return (
    <section className="relative w-full overflow-hidden" aria-label="Editorial Auréa">
      <div className="absolute inset-0 h-full w-full">
        <img
          src={image}
          alt={alt}
          title="Elegância que começa nos seus passos — Auréa"
          loading="lazy"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/15" />
      </div>

      <div className="relative z-10 flex min-h-[420px] w-full items-center px-4 py-16 md:px-8 md:py-20">
        <Reveal className="mx-auto w-full max-w-6xl">
          <div className="max-w-xl">
            <span className="text-[11px] uppercase tracking-[0.28em] text-accent-300">{eyebrow}</span>
            <h2 className="mt-4 font-heading text-3xl font-medium leading-tight text-background-50 md:text-5xl">
              {title}
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-background-100 md:text-base">{text}</p>
            <a
              href="#selecao"
              className="mt-8 inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              {button}
              <i className="ri-arrow-right-line text-base" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}